import { render, staticRenderFns } from "./UserScientificDegreeUpdate.vue?vue&type=template&id=2a493aa4&"
import script from "./UserScientificDegreeUpdate.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports